import { render, staticRenderFns } from "./NetGsmWebhooks.vue?vue&type=template&id=ef24bd16&scoped=true"
import script from "./NetGsmWebhooks.vue?vue&type=script&lang=js"
export * from "./NetGsmWebhooks.vue?vue&type=script&lang=js"
import style0 from "./NetGsmWebhooks.vue?vue&type=style&index=0&id=ef24bd16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef24bd16",
  null
  
)

export default component.exports